import {HttpErrorResponse} from '@angular/common/http';

export class HttpCodesUtil {
    /**
     * Returns true if error contains a HTTP status code of 502: BadGateway or 503: Service Unavailable
     */
    public static isServerUnderMaintenance(error: any): boolean {
        return error instanceof HttpErrorResponse
            && (error.status === 502 || error.status === 503);
    }

    /**
     * Returns true if error contains a HTTP status code of 403: Forbidden
     */
    public static isForbidden(error: any): boolean {
        return error instanceof HttpErrorResponse && error.status === 403;
    }

    /**
     * Returns true if error contains a HTTP status code of 404: Not Found
     */
    public static isNotFound(error: any): boolean {
        return error instanceof HttpErrorResponse && error.status === 404;
    }

    public static isClientSideError(error: any): boolean {
        return error instanceof HttpErrorResponse && error.status >= 400 && error.status < 500;
    }

    public static isUnauthorizedError(error: any): boolean {
        return error instanceof HttpErrorResponse && error.status === 401;
    }

    public static isStaleAuthenticationError(error: any): boolean {
        return HttpCodesUtil.isUnauthorizedError(error)
            && error.error?.['labelKey'] === 'error.authentication.stale';
    }
}
